import React from 'react';
import { FormattedMessage } from 'react-intl';

import Breadcrumb from '../../../../Breadcrumb';

const QuotesBreadCrumbs = () => (
  <Breadcrumb className="pd-mb-3">
    <Breadcrumb.Item to="../../..">
      <FormattedMessage id="account.index.title" defaultMessage="My account" />
    </Breadcrumb.Item>
    <Breadcrumb.Item to="../..">
      <FormattedMessage id="quotes.title" defaultMessage="My Quotes" />
    </Breadcrumb.Item>
    <Breadcrumb.Item isCurrentPage>
      <FormattedMessage id="account.quotes.form.pageTitle" defaultMessage="Request a quote" />
    </Breadcrumb.Item>
  </Breadcrumb>
);

export default QuotesBreadCrumbs;
